module.exports = __webpack_public_path__ + "static/media/tractorPlow_black.767e1b2a.svg";